import { useState } from "react";
import useFetchMetaData from "../../../hooks/useFetchMetaData";
import { useFormik } from "formik";
import * as yup from "yup";
import useDeleteData from "../../../hooks/useDeleteData";
import { GetAccess } from "../../../utils/RolesandAccess";
import { SubmitButton } from "../../../utils/Button";
import useAddData from "../../../hooks/useAddData";
import { NuInput } from "../../../utils/Inputs";
import { RoleLoader } from "../../../components/Loader";
import { DeleteIcon } from "../../../assets/icons";

function IncidentIndex() {
  const { metaData, getData, loading } = useFetchMetaData({
    value: "incident_type",
    create:true
  });
  const { isCreateLoading, addData } = useAddData();
  const { handleDelete } = useDeleteData();
  const [value, setValue] = useState({
    property_name: "",
    value: "",
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: value,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      value: yup.string().required("Vendor Type is Required"),
    }),
    onSubmit: (value, { resetForm }) => {
      value.property_name = "incident_type";
      addData({
        url: "/Master-Data/",
        value: value,
        resetForm: resetForm,
        onClose: ()=>{},
        getData: getData,
      });
    },
  });

  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
          Incident Type
          </h4>
        </div>

        <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto">
          {GetAccess("admin_create") && (
            <form onSubmit={formik.handleSubmit}>
              <div className="w-[60%] mx-auto flex lg:justify-center">
                <NuInput
                  formik={formik}
                  name="value"
                  label="Incident Type"
                  width="w-full"
                  placeholder="Incident Type"
                />
                <div className="flex items-center mr-8 mt-7">
                  <SubmitButton isLoading={isCreateLoading} />
                </div>
              </div>
            </form>
          )}
          <div className="w-[60%] mx-auto border border-black px-4 py-2 rounded-lg">
            {loading == true ? (
              <>
                <>
                  {[...Array(16)].map((_, index) => {
                    return <RoleLoader />;
                  })}
                </>
              </>
            ) : (
              <>
                {metaData.map((data, i) => (
                  <div className="flex justify-between my-3" key={i}>
                    <p className="text-xs py-1">{data?.value}</p>
                    {GetAccess("admin_delete") && (
                      <span
                        onClick={()=>handleDelete({
                          url: `/Master-Data/${data.id}`,
                          id: data.id,
                          value: data.value,
                          fetcher: getData,
                        })}
                      >
                        <DeleteIcon />
                      </span>
                    )}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default IncidentIndex;
